<template>
  <!-- From payment consolidate Create Payout Button Launch Modal -->
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Create payout record</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-combobox
                :items="campaigns"
                :search-input.sync="search"
                :error-messages="selectedCampaignErrors"
                hide-details="auto"
                item-text="name"
                @input="$v.payout.campaign.$touch()"
                @blur="$v.payout.campaign.$touch()"
                @change="changeCampaign()"
                v-model="payout.campaign"
                label="Campaign Name"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ search }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-combobox
                :items="clients"
                :search-input.sync="searchClient"
                hide-details="auto"
                v-model="payout.client"
                item-text="name"
                label="Client"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ searchClient }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-combobox
                :items="influencers"
                item-text="handle"
                hide-details="auto"
                v-model="payout.handle"
                label="Influencers"
                prefix="@"
                dense
                outlined
                @input="$v.payout.handle.$touch()"
                @blur="$v.payout.handle.$touch()"
                @change="changeInfluencer()"
                :error-messages="handleErrors"
              >
                <template v-slot:item="{ item }">
                  <social-handle-view
                    divClassName="d-inline"
                    :isTikTok="item.platform === 'tiktok'"
                    :isInstagram="!item.platform || item.platform === 'instagram'"
                    :isYoutube="item.platform === 'youtube'"
                    :isFacebook="item.platform === 'facebook'"
                    :isXiaohongshu="item.platform === 'xiaohongshu'"
                    :tiktokHandle="item.handle"
                    :instagramHandle="item.handle"
                    :youtubeHandle="item.handle"
                    :facebookHandle="item.handle"
                    :xiaohongshuHandle="item.handle"
                  />
                </template>
              </v-combobox>
            </v-col>
            <!-- <v-col cols="12" md="6" sm="12">
              <v-select
                :items="allowedStatusesForPayoutCreate"
                item-value="status"
                item-text="display"
                hide-details="auto"
                v-model="payout.status"
                :error-messages="statusErrors"
                @input="$v.payout.status.$touch()"
                @blur="$v.payout.status.$touch()"
                label="Status"
                dense
                outlined
              >
              </v-select>
            </v-col> -->
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Swift Code"
                hide-details="auto"
                v-model="payout.bankSwiftCode"
                @input="$v.payout.bankSwiftCode.$touch()"
                @blur="$v.payout.bankSwiftCode.$touch()"
                :error-messages="bankSwiftCodeErrors"
                placeholder="RABONL2U"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Bank A/C No."
                placeholder="Bank A/C No.(omit dashes)"
                v-model="payout.bankAccountNo"
                :error-messages="bankNoErrors"
                hide-details="auto"
                @input="$v.payout.bankAccountNo.$touch()"
                @blur="$v.payout.bankAccountNo.$touch()"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Payee Name"
                placeholder="Payee Name."
                :error-messages="receivingNameErrors"
                v-model="payout.receivingName"
                hide-details="auto"
                @input="$v.payout.receivingName.$touch()"
                @blur="$v.payout.receivingName.$touch()"
                outlined
                dense
              ></v-text-field>
              <caption class="font-weight-bold" style="min-width:200px" v-if="payout.handle">Paired Amount: {{utilsFunc.currencySym(payout.currency)}} {{payout.handle.amount || 0}}</caption>
              <!-- <caption class="font-weight-bold pb-0" style="min-width:200px" v-if="payout.currency !== 'SGD'">Paid Amount: {{utilsFunc.currencySym(payout.currency)}} {{payout.convertedPaidAmt}} (Actual: S$ {{payout.paidAmt || 0}})</caption>
              <caption class="font-weight-bold pb-0" style="min-width:200px" v-if="payout.currency === 'SGD'">Paid Amount: (S$ {{payout.paidAmt || 0}})</caption> -->
              <caption class="font-weight-bold pb-0" style="min-width:200px" v-if="payout.completedCurrency && payout.completedCurrency === 'SGD'">
                Paid Amount: S$ {{payout.paidAmt || 0}}<br>
                <span v-if="payout.currency !== 'SGD'">(Est: {{utilsFunc.currencySym(payout.currency)}} {{payout.convertedEstAmt}})</span>
              </caption>
              <caption class="font-weight-bold pb-0 pt-0" style="min-width:200px" v-if="payout.completedCurrency && payout.completedCurrency !== 'SGD'">
                Paid Amount: {{utilsFunc.currencySym(payout.completedCurrency)}} {{payout.paidAmt || 0}}&nbsp;<br>
                <span v-if="payout.actualAmount">(Actual: S$ {{ payout.actualAmount }})</span>&nbsp;<br>
                <span>(Est: {{ utilsFunc.currencySym(payout.completedCurrency) }} {{payout.convertedEstAmt}})</span>
              </caption>
              <caption class="font-weight-bold pb-0" style="min-width:200px" v-if="payout.handle && !payout.completedCurrency">Paid Amount: 0</caption>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Amount"
                type="number"
                v-model="payout.amount"
                @input="checkUnpaidAmount()"
                @blur="$v.payout.amount.$touch()"
                placeholder="300"
                :prefix="payout.currency"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
              <span class="text-danger ma-0 pt-1" v-if="unPaidAmtErr">Amount entered is exceeding than remain amount.</span>
              <caption class="font-weight-bold pb-0" style="min-width:200px" v-if="payout.processingAmt !== ''">Processing Amount: {{utilsFunc.currencySym(payout.currency)}} {{payout.processingAmt || 0}}</caption>
              <caption class="font-weight-bold pb-0" style="min-width:200px" v-if="payout.remainAmt !== ''">Remaining Amount: {{utilsFunc.currencySym(payout.currency)}} {{payout.remainAmt || 0}}</caption>
            </v-col>
          </v-row>
          <!-- <div class="mt-2 mb-3">
            <p class="ma-0 pt-1" style="color: #fb8c00 !important">
              <v-icon small color="warning">mdi-alert-circle-outline</v-icon> This is only for special payment terms TRUE influencers.
            </p>
          </div> -->
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="payout.live_date"
                v-on="on"
                dense
                outlined
                label="Live Date (DD/MM/YYYY)"
                hide-details="auto"
                :error-messages="liveDateErrors"
                @blur="$v.payout.live_date.$touch()"
                @input="changeLiveDate"
                @keyup.enter="changeLiveDate"
              ></v-text-field>
              <span class="text-danger ma-0 pt-1" v-if="isInvalidLiveDate">Invalid Live Date</span>
              <span class="text-danger ma-0 pt-1" v-if="!isInvalidLiveDate && !payout.live_date">Required</span>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="payout.due_date"
                v-on="on"
                dense
                outlined
                label="Due Date (DD/MM/YYYY)"
                hide-details="auto"
                :error-messages="dueDateErrors"
                @blur="$v.payout.due_date.$touch()"
              ></v-text-field>
              <span class="text-danger ma-0 pt-1" v-if="!payout.due_date">Required</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12" v-if="isBankRef">
              <v-text-field
                label="Bank Reference"
                placeholder="BK19010043050112"
                persistent-hint
                v-model="payout.bank_reference"
                hide-details="auto"
                outlined
                dense
              ></v-text-field>
              <p class="ma-0 pt-1" style="color: #fb8c00 !important">
                <v-icon small color="warning">mdi-alert-circle-outline</v-icon> For Finance Only
              </p>
            </v-col>
            <v-col cols="12" md="6" sm="12" v-if="isPaymentDate">
              <v-text-field
                v-model="payout.payment_date"
                v-on="on"
                dense
                outlined
                label="Payment Date (DD/MM/YYYY)"
                hide-details="auto"
              ></v-text-field>
              <p class="ma-0 pt-1" style="color: #fb8c00 !important">
                <v-icon small color="warning">mdi-alert-circle-outline</v-icon> For Finance Only
              </p>
            </v-col>
            <!-- <v-col cols="12" md="6" sm="12" v-if="isPaymentSubmissionDate">
              <v-text-field
                v-model="payout.payment_submission_date"
                :error-messages="paymentSubmissionDateErrors"
                @input="$v.payout.payment_submission_date.$touch()"
                @blur="$v.payout.payment_submission_date.$touch()"
                v-on="on"
                outlined
                dense
                label="Submission Date (DD/MM/YYYY)"
                hide-details="auto"
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-checkbox
                v-model="payout.chkGST"
                hide-details
                label="Include GST 9%"
              >
              </v-checkbox>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <v-textarea
                hide-details
                label="Remarks"
                v-model="payout.remarks"
                dense
                outlined
                style="width:100%"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <custom-file-upload
                :refresh="fileUploadRefresh"
                @setMedias="updateInvoices"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="green darken-1" :disabled="disableSavePayout" text @click="savePayout">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-row>
</template>
<script>
/* eslint-disable */
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
// import paymentAPIs from './paymentAPIs';
import campaignAPIs from '../Campaign/campaignAPIs';
import userAPIs from '../User/userAPIs';
import clientAPIs from '../Client/clientAPIs';
import pairingAPIs from '../Pairing/pairingAPIs';
import influencerAPIs from '../Influencer/influencerAPIs'
import config from '@/config';
import { mapState, mapGetters } from 'vuex';
import Loading from 'vue-loading-overlay';
import CustomFileUpload from '../../scoped/custom/CustomFileUpload';
import SocialHandleView from '@/components/scoped/custom/SocialHandleView'
import utils from '@/utils';
import moment from 'moment'
import campaignConfig from '@/components/views/Campaign/config';
export default {
  components: {
    Loading,
    CustomFileUpload,
    SocialHandleView
  },
  mixins: [validationMixin],
  props: {
    value: Boolean,
    reports: Array,
    editData: Object,
    reportUpdate: Boolean
  },
  validations: function() {
    return this.rules
  },
  data() {
    return {
      payout: {
        bankAccountNo: null,
        receivingName: null,
        handle: null,
        bankSwiftCode: null,
        status: campaignConfig.paymentStatus.PROCESSING,
        campaign: null,
        bank_reference: '',
        payment_date: '',
        payment_submission_date: '',
        live_date: '',
        due_date: '',
        amount: '',
        remainAmt: '',
        paidAmt: '',
        processingAmt: '',
        chkGST: false,
        remarks: ''
      },
      pickDate: false,
      userCs: [],
      search: null,
      searchCs: null,
      campaigns: [],
      clients: [],
      influencers: [],
      searchClient: null,
      sales: [],
      invoiceFiles: [],
      fileUploadRefresh: 1,
      isLoading: false,
      isInvalidLiveDate: false,
      unPaidAmtErr: false,
      preProcessingPayments: [],
      importedPayments: [],
      formattedCompletedPayments: [],
      financePayments: [],
      utilsFunc: utils.func
    };
  },
  computed: {
    ...mapState({
      paymentStatuses: state => state.payment.status,
      currencyRates: state => state.payment.currencyRates
    }),
    ...mapGetters('payment', [
      'allowedStatuses',
      'allowedStatusesForPayoutCreate',
      'formatPreProcessingPayments',
      'formatImportedPayments',
      'formatCompletedPayments',
      'formatFinancePayments',
      'isPaymentConsolidationRecordMatch'
    ]),
    rules() {
      const validationRules = {
        payout: {
          campaign: {
            required
          },
          handle: {
            required
          },
          status: {
            required
          },
          amount: {
            required
          },
          live_date: {
            required
          },
          due_date: {
            required
          }
        }
      }
      // if (this.isBankRef) validationRules.payout.bank_reference = { required }
      // if (this.isPaymentDate) validationRules.payout.payment_date = { required }
      // if (this.isPaymentSubmissionDate) validationRules.payout.payment_submission_date = { required }
      // validation check for bank infos
      if (this.isBankInfoRequired) {
        validationRules.payout.bankSwiftCode = { required }
        validationRules.payout.bankAccountNo = { required }
        validationRules.payout.receivingName = { required }
      } else {
        validationRules.payout.bankSwiftCode = {}
        validationRules.payout.bankAccountNo = {}
        validationRules.payout.receivingName = {}
      }
      // commented for no need validation - validation checks for special payments
      // if (this.isSpecialPayment) {
      //   validationRules.payout.live_date = { required }
      //   validationRules.payout.due_date = { required }
      // } else {
      //   validationRules.payout.live_date = {}
      //   validationRules.payout.due_date = {}
      // }
      return validationRules
    },
    selectedCampaignErrors() {
      const errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    bankNoErrors() {
      const errors = [];
      if (this.isBankInfoRequired) {
        if (!this.$v.payout.bankAccountNo.$dirty) return errors;
        !this.$v.payout.bankAccountNo.required && errors.push('This field is required.');
      }
      return errors;
    },
    receivingNameErrors() {
      const errors = [];
      if (this.isBankInfoRequired) {
        if (!this.$v.payout.receivingName.$dirty) return errors;
        !this.$v.payout.receivingName.required && errors.push('This field is required.');
      }
      return errors;
    },
    handleErrors() {
      const errors = [];
      if (!this.$v.payout.handle.$dirty) return errors;
      !this.$v.payout.handle.required && errors.push('This field is required.');
      return errors;
    },
    bankSwiftCodeErrors() {
      const errors = [];
      if (this.isBankInfoRequired) {
        if (!this.$v.payout.bankSwiftCode.$dirty) return errors;
        !this.$v.payout.bankSwiftCode.required && errors.push('This field is required.');
      }
      return errors;
    },
    csNameErrors() {
      const errors = [];
      if (!this.$v.payout.csName.$dirty) return errors;
      !this.$v.payout.csName.required && errors.push('This field is required.');
      return errors;
    },
    BIBREFErrors() {
      const errors = [];
      if (!this.$v.payout.BIBREF.$dirty) return errors;
      !this.$v.payout.BIBREF.required && errors.push('This field is required.');
      return errors;
    },
    FTREFErrors() {
      const errors = [];
      if (!this.$v.payout.FTREF.$dirty) return errors;
      !this.$v.payout.FTREF.required && errors.push('This field is required.');
      return errors;
    },
    REFErrors() {
      const errors = [];
      if (!this.$v.payout.REF.$dirty) return errors;
      !this.$v.payout.REF.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors() {
      const errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    statusErrors() {
      const errors = [];
      if (!this.$v.payout.status.$dirty) return errors;
      !this.$v.payout.status.required && errors.push('This field is required.');
      return errors;
    },
    bankRefErrors() {
      const errors = [];
      if (!this.$v.payout.bank_reference.$dirty) return errors;
      !this.$v.payout.bank_reference.required && errors.push('This field is required.');
      return errors;
    },
    paymentDateErrors() {
      const errors = [];
      if (!this.$v.payout.payment_date.$dirty) return errors;
      !this.$v.payout.payment_date.required && errors.push('This field is required.');
      return errors;
    },
    paymentSubmissionDateErrors() {
      const errors = [];
      if (!this.$v.payout.payment_submission_date.$dirty) return errors;
      !this.$v.payout.payment_submission_date.required && errors.push('This field is required.');
      return errors;
    },
    liveDateErrors() {
      const errors = [];
      if (this.isSpecialPayment) {
        if (!this.$v.payout.live_date.$dirty) return errors;
        !this.$v.payout.live_date.required && errors.push('This field is required.');
      }
      return errors;
    },
    dueDateErrors() {
      const errors = [];
      if (this.isSpecialPayment) {
        if (!this.$v.payout.due_date.$dirty) return errors;
        !this.$v.payout.due_date.required && errors.push('This field is required.');
      }
      return errors;
    },
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isBankRef() {
      return this.currentUserRole !== config.userRoles.AD_STRATEGIST
    },
    isPaymentDate() {
      return this.currentUserRole !== config.userRoles.AD_STRATEGIST
    },
    isPaymentSubmissionDate() {
      return this.currentUserRole !== config.userRoles.AD_STRATEGIST
    },
    isBankInfoRequired() {
      return this.payout.status === this.paymentStatuses.APPROVAL_FINANCE.value
    },
    isSpecialPayment() {
      return this.payout.handle && this.payout.handle.specialPayment
    },
    disableSavePayout() {
      return this.$v.payout.$invalid || this.unPaidAmtErr || this.isInvalidLiveDate
    }
  },
  watch: {
    value: async function (newValue) {
      // Closing the dialog changes value to false. Only an open dialog needs
      // fresh lookup and payment data; fetching again on close is redundant.
      if (!newValue) return
      await this.fetchCampaigns();
      await this.fetchCSs();
      await Promise.all([
        this.fetchClient(),
        this.fetchSales(),
        this.fetchPreProcessingPayments(),
        this.fetchImportedPayments(),
        this.fetchCompletedPayments(),
        this.fetchFinancePayments()
      ])
      // this.payout.campaign = null
      this.resetForm()
    },
    editData: async function (newValue) {
      if (newValue.update) {
        // for invoice update, check and update in invoice
        this.payout.id = newValue.id
        this.payout.update = true
      }
      if (!this.campaigns.length) {
        await this.fetchCampaigns();
      }
      let campaign = this.campaigns.find(c => c.id === newValue.campaignID)
      this.payout.campaign = campaign
      await this.changeCampaign()
      this.payout.handle = this.influencers.find(i => i.handle === this.editData.instagram)
      await this.changeInfluencer()
      this.payout.live_date = this.editData.liveDate
      this.payout.due_date = this.editData.dueDate
      this.payout.amount = this.editData.amount
      this.payout.bank_reference = this.editData.bankReference
      this.payout.payment_date = this.editData.paymentDate || ''
      this.payout.payment_submission_date = this.editData.paymentSubmissionDate || ''
      this.payout.chkGST = this.editData.GST || false
      this.payout.remarks = this.editData.remarks
      this.payout.status = this.allowedStatusesForPayoutCreate.find(al => al.status === this.editData.paymentStatus)
      if (!this.payout.bankSwiftCode && this.editData.swiftCode) {
        this.payout.bankSwiftCode = this.editData.swiftCode || ''
      }
      if (!this.payout.bankAccountNo && this.editData.bankAccount) {
        this.payout.bankAccountNo = this.editData.bankAccount || ''
      }
      if (!this.payout.receivingName && this.editData.fullName) {
        this.payout.receivingName = this.editData.fullName || ''
      }
    }
  },
  mounted() {
    // mounted here
  },
  methods: {
    close() {
      this.$emit('input');
    },
    async savePayout() {
      try {
        this.isLoading = true;
        const formData = this.constructData(this.payout);
        await campaignAPIs.savePaymentConsolidatedPayout(formData);
        this.fetchCompletedPayments()
        this.isLoading = false;
        this.$emit('created');
        this.$emit('input');
        this.$swal({
          text: this.payout.id ? 'Successfully updated payout record' : 'New payout record is created',
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        this.$swal({
          text: error.message,
          type: 'error'
        });
      }
    },
    async fetchCampaigns() {
      try {
        const data = await campaignAPIs.getPayoutCampaignPicker();
        const campaigns = data.campaigns;
        this.campaigns = campaigns.map(cmp => {
          return {
            name: cmp.ioNumbers ? `${cmp.ioNumbers} - ${cmp.name}` : cmp.name,
            id: cmp.id,
            assignedTo: cmp.assignedTo,
            clientID: cmp.clientID
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of campaigns',
          icon: 'error'
        });
      }
    },
    filterClientByCampaigns(clientID) {
      const client = this.clients.find(cmp => cmp.id === clientID);
      return client;
    },
    filterCsByCampaigns(campaignName) {
      if (!campaignName) return null;
      const userCampaign = this.campaigns.find(c => c.name === campaignName)
      if (!userCampaign) return null;
      const cs = this.userCs.filter(user => userCampaign.assignedTo && userCampaign.assignedTo.find(item => user.id === item));
      return cs;
    },
    constructData(input) {
      let formData = new FormData();
      let defaultCreateData = {
        imported: true,
        campaignID: input.campaign.id,
        pairingID: input.handle.pairingID || '',
        payment_status: input.status && input.status.status ? input.status.status : input.status,
        amount: input.amount ? Number(parseFloat(input.amount).toFixed(2)) : '',
        GST: input.chkGST,
        remarks: input.remarks
      }
      if (input.id && input.update) defaultCreateData.id = input.id
      if (input.bank_reference) defaultCreateData.bank_reference = input.bank_reference
      if (input.payment_date) defaultCreateData.payment_date = input.payment_date
      if (input.invoices) defaultCreateData.invoices = input.invoices
      if (input.live_date && this.isDateValid(input.live_date)) defaultCreateData.live_date = this.parseDate(input.live_date)
      if (input.due_date && this.isDateValid(input.due_date)) defaultCreateData.due_date = this.parseDate(input.due_date)
      let data = Object.assign({}, {
        influencerID: input.handle.influencerID || '',
        handle: input.handle.handle,
        platform: input.handle.platform,
        swift_code: input.bankSwiftCode,
        bank_account: input.bankAccountNo,
        fullName: input.receivingName
      });
      const userCampaign = this.campaigns.find(c => c.id === input.campaign.id)
      if (userCampaign) {
        if (Array.isArray(userCampaign.assignedTo)) {
          const cs = this.userCs.filter(user => userCampaign.assignedTo && userCampaign.assignedTo.find(item => user.id === item));
          defaultCreateData.CC = cs || []
        }
      }
      data.defaultCreateData = defaultCreateData
      formData.append('data', JSON.stringify(data))
      if (this.reportUpdate) formData.append('reportUpdate', true)
      for (let val of this.invoiceFiles) {
        formData.append('isInvoice', true)
        formData.append('uploadFile', val)
      }
      return formData;
    },
    async changeCampaign() {
      this.resetForm()
      let newValue = this.payout.campaign
      if (newValue && newValue.clientID) {
        this.payout.client = this.filterClientByCampaigns(newValue.clientID);
      }
      if (newValue && newValue.name) {
        this.payout.cs = this.filterCsByCampaigns(newValue.name);
        try {
          // get pairing influencers
          const resp = await pairingAPIs.getPairedInfluencersByCampaign(newValue.id)
          this.setInfluencers(resp)
          // this.refreshPairingInfs()
        } catch (error) {
          console.log(error);
          this.$swal({
            text: 'Cannot fetch the list of Influencers',
            icon: 'error'
          });
        }
      }
    },
    setInfluencers(resp) {
      resp = resp.filter(r => {
        if (r.pairing_details && r.pairing_details.status) {
          if (r.pairing_details.status === config.pairingStatus.ACCEPTED) {
            return true
          }
        }
        return false
      })
      this.influencers = resp.map(pairing => {
        if (pairing.influencer_details) {
          let influencerDetails = pairing.influencer_details
          let payoutDetails = pairing.payout_details
          let specialPayment = false
          if (pairing.pairing_details) {
            specialPayment = pairing.pairing_details.SpecialPaymentTerms || false
          }
          let respData = Object.assign({}, {
            pairingID: pairing.id,
            campaignID: pairing.campaignID,
            influencerID: influencerDetails.influencerID || '',
            handle: influencerDetails.instagramHandle,
            platform: influencerDetails.platform || 'instagram',
            amount: payoutDetails.amount || 0,
            currency: payoutDetails.currency || 'SGD',
            specialPayment
          })
          // if (respData.platform === 'xiaohongshu') {
          //   respData.handle = influencerDetails.fullName
          // }
          return respData
        }
      })
    },
    calcPaidAmt(campaignID, handle, influencerID) {
      let usedAmts = 0
      let actualAmount = 0
      let completedCurrency = 'SGD'
      this.formattedCompletedPayments.map(rpt => {
        if (this.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0)
          completedCurrency = rpt.currency
          actualAmount = rpt.actualAmount || 0
        }
      })
      return {
        usedAmts,
        completedCurrency,
        actualAmount
      }
    },
    calcProcessingAmt(campaignID, handle, amt, influencerID) {
      let usedAmts = 0
      this.preProcessingPayments.map(rpt => {
        if (rpt.imported && this.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0)
        }
      })
      this.importedPayments.map(rpt => {
        if (this.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0)
        }
      })
      this.financePayments.map(rpt => {
        if (this.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0)
        }
      })
      return (usedAmts).toFixed(2)
    },
    async changeInfluencer() {
      this.payout.bankSwiftCode = null
      this.payout.bankAccountNo = null
      this.payout.receivingName = null
      this.payout.remainAmt = 0
      this.payout.currency = 'SGD'
      this.payout.status = this.paymentStatuses.PROCESSING.value
      if (this.payout.handle) {
        this.payout.processingAmt = this.calcProcessingAmt(this.payout.handle.campaignID || '', this.payout.handle.handle, null, this.payout.handle.influencerID)
        this.payout.currency = this.payout.handle.currency
        let completedPaymentObj = this.calcPaidAmt(this.payout.handle.campaignID || '', this.payout.handle.handle, this.payout.handle.influencerID)
        this.payout.completedCurrency = ''
        this.payout.actualAmount = 0
        if (completedPaymentObj) {
          this.payout.completedCurrency = completedPaymentObj.completedCurrency
          this.payout.paidAmt = completedPaymentObj.usedAmts
          this.payout.actualAmount = completedPaymentObj.actualAmount
        }
        // disable currency conversion
        let convertedPaidAmt = 0
        if (this.payout.currency) {
          if (this.payout.currency !== 'SGD') {
            convertedPaidAmt = utils.func.convertCurrency(this.payout.currency, this.payout.paidAmt, this.currencyRates)
          } else {
            convertedPaidAmt = this.payout.paidAmt
          }
        } else {
          convertedPaidAmt = this.payout.paidAmt
        }
        this.payout.convertedPaidAmt = convertedPaidAmt
        // completed currency est amt
        let convertedEstAmt = 0
        if (this.payout.completedCurrency) {
          if (this.payout.completedCurrency === 'SGD') {
            convertedEstAmt = utils.func.convertOtherCurrency(this.payout.currency, this.payout.paidAmt, this.currencyRates)
          } else {
            convertedEstAmt = this.payout.paidAmt
          }
        } else {
          convertedEstAmt = this.payout.paidAmt
        }
        this.payout.convertedPaidAmt = convertedPaidAmt
        this.payout.convertedEstAmt = convertedEstAmt
        if (this.payout.currency) {
          if (this.payout.currency === 'SGD') {
            if (this.payout.completedCurrency !== 'SGD') {
              let sgdPaidAmt = utils.func.convertCurrency(this.payout.completedCurrency, this.payout.convertedEstAmt, this.currencyRates)
              this.payout.remainAmt = (Number(this.payout.handle.amount) - (Number(this.payout.processingAmt) + Number(sgdPaidAmt))).toFixed(2)
            } else {
              this.payout.remainAmt = (Number(this.payout.handle.amount) - (Number(this.payout.processingAmt) + Number(convertedPaidAmt))).toFixed(2)
            }
          } else {
            this.payout.remainAmt = (Number(this.payout.handle.amount) - (Number(this.payout.processingAmt) + Number(convertedEstAmt))).toFixed(2)
          }
        }
        this.payout.currency = this.payout.handle.currency || 'SGD'
      }
      if (this.payout.handle && this.payout.handle.influencerID) {
        try {
          const resp = await influencerAPIs.getInfluencer(this.payout.handle.influencerID)
          if (!this.payout.bankSwiftCode) {
            this.payout.bankSwiftCode = resp.swiftCode || ''
          }
          if (!this.payout.bankAccountNo) {
            this.payout.bankAccountNo = resp.bankAccount || ''
          }
          if (!this.payout.receivingName) {
            this.payout.receivingName = resp.fullName || ''
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            text: 'Cannot fetch Influencer Data',
            icon: 'error'
          });
        }
      }
    },
    async fetchCSs() {
      try {
        const resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST);
        const users = resp.users;
        this.userCs = users.map(user => {
          return {
            name: `${user.firstName} ${user.lastName}`,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of CS',
          icon: 'error'
        });
      }
    },
    async fetchClient() {
      try {
        const resp = await clientAPIs.getAllClients(true);
        const clients = resp.data;
        this.clients = clients.map(user => {
          return {
            name: user.name,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of clients',
          icon: 'error'
        });
      }
    },
    async fetchSales() {
      try {
        const resp = await userAPIs.getAllUsersByRole(config.userRoles.COMPANY_ADMIN_LOW);
        const users = resp.users;
        this.sales = users.map(user => {
          return {
            id: user.id,
            name: `${user.firstName} ${user.lastName}`
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of CS',
          icon: 'error'
        });
      }
    },
    resetForm() {
      this.payout.bankAccountNo = null
      this.payout.receivingName = null
      this.payout.handle = null
      this.payout.bankSwiftCode = null
      this.payout.status = campaignConfig.paymentStatus.PROCESSING
      this.payout.bank_reference = ''
      this.payout.payment_date = ''
      this.payout.payment_submission_date = ''
      this.payout.live_date = ''
      this.payout.due_date = ''
      this.payout.amount = ''
      this.payout.remainAmt = ''
      this.payout.paidAmt = ''
      this.payout.processingAmt = ''
      this.influencers = []
      this.invoiceFiles = []
      this.fileUploadRefresh += 1
    },
    updateInvoices(medias) {
      this.invoiceFiles = Object.assign([], medias)
    },
    changeLiveDate() {
      this.$v.payout.live_date.$touch()
      this.isInvalidLiveDate = false
      this.payout.due_date = ''
      if (!this.isDateValid(this.payout.live_date)) {
        this.isInvalidLiveDate = true
        return;
      }
      let dueDate = this.payout.live_date ? moment(this.parseDate(this.payout.live_date)).add(30, 'days').format('YYYY-MM-DD') : ''
      dueDate = this.formatDate(dueDate)
      this.payout.due_date = dueDate
    },
    checkUnpaidAmount() {
      this.$v.payout.amount.$touch()
      this.unPaidAmtErr = false
      if (Number(this.payout.remainAmt) < Number(this.payout.amount)) {
        this.unPaidAmtErr = true
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      let formattedDate = `${day}/${month}/${year}`
      if (formattedDate.includes('undefined')) {
        return date
      }
      return formattedDate;
    },
    isDateValid(givenDate) {
      if (!givenDate) return true
      let regex = config.regexPattern.date_format
      if (givenDate.match(regex)) return true
      return false
    },
    async fetchCompletedPayments() {
      // get completed reports
      await this.$store.dispatch('payment/getCompletedPayments', {})
      this.formattedCompletedPayments = this.formatCompletedPayments(this.userCs)
    },
    async fetchPreProcessingPayments() {
      await this.$store.dispatch('payment/getPreProcessingPayments', {})
      this.preProcessingPayments = this.formatPreProcessingPayments(this.userCs)
    },
    async fetchImportedPayments() {
      await this.$store.dispatch('payment/getImportedPayments', {})
      this.importedPayments = this.formatImportedPayments(this.userCs)
    },
    async fetchFinancePayments() {
      // get completed reports
      await this.$store.dispatch('payment/getFinancePayments', {})
      this.financePayments = this.formatFinancePayments(this.userCs)
    },
    async refreshPairingInfs() {
      for (let inf of this.influencers) {
        if (inf.influencerID) {
          await pairingAPIs.refreshInfluencerDetails({ighandle: inf.handle, campaignID: inf.campaignID, platform: inf.platform.toLowerCase(), pairingID: inf.pairingID})
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// CreatePaymentConsolidateModal.vue?082b736a